export default "__VITE_PUBLIC_ASSET__8f09f102__"